import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Platform, View } from 'react-native';

import { Loader } from '../../common/Loader';
import type { IVideoPlayerStore } from './VideoPlayer';

const Container = styled(View)({
  position: 'absolute',
  height: '100%',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
});

export interface IVideoPlayerLoaderProps {
  store: IVideoPlayerStore;
}

export const VideoPlayerLoader = observer<IVideoPlayerLoaderProps>(
  ({ store }) => {
    return (
      <Container pointerEvents="none">
        {store.isLoading && (
          <Loader
            color="$background0"
            size={Platform.select({ web: 'large' })}
          />
        )}
      </Container>
    );
  },
);
